import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Modal from "../../components/Modal";

const CGPA = () => {
  const [sems, setSems] = useState(8);
  const [result, setResult] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRegulation, setSelectedRegulation] = useState(null);

  const [gpas, setGpas] = useState(Array(8).fill(0));
  const [credits, setCredits] = useState(Array(8).fill(0));

  const deptCredits2019 = {
    CSE: [21, 19, 25, 21, 22, 23, 20, 12],
    IT: [18.5, 21, 21, 22, 22, 21, 22, 12],
    AIML: [21, 21, 24, 24, 22, 22, 22, 12],
    ADS: [18.5, 22, 24, 25, 22, 23, 21, 12],
    ECE: [21, 20, 21, 19, 22, 22, 23, 12],
    EEE: [18.5, 20, 24, 24.5, 21, 24, 20, 12],
    MECH: [19.5, 20.5, 24, 19, 22, 25, 23, 12],
    CIVIL: [20.5, 20.5, 20, 19, 22, 23, 23, 12],
    BME: [21, 20, 21, 19, 22, 22, 21, 12],
    FT: [18, 20, 23, 22, 24, 22, 23, 12],
    MCT: [20, 21, 21, 22, 21, 22, 21, 12],
    CSD: [21, 21, 24, 23, 22, 25, 22, 12],
  };

  const deptCredits2023 = {
    CSE: [20, 21, 23, 21, 22, 22, 0, 0],
    IT: [20, 20, 23, 22, 24, 24, 0, 0],
    AIML: [19, 21, 21, 21, 22, 22, 0, 0],
    AIDS: [20, 20, 23, 22, 24, 21, 0, 0],
    CSD: [19, 21, 21, 20, 22, 23, 0, 0],
    EEE: [19, 19.5, 24, 24.5, 23, 23.5, 0, 0],
    ECE: [21, 21, 25, 24, 23, 24, 0, 0],
    BME: [20, 21, 24, 23, 22, 23, 0, 0],
    MECH: [21, 20, 23, 25, 23, 25, 0, 0],
    CIVIL: [21, 20, 23, 21, 24, 23, 0, 0],
    MCT: [21, 21, 22, 24, 24, 22, 0, 0],
    FT: [18, 21, 22, 22, 24, 22, 0, 0],
    EFE: [19, 20.5, 23.5, 25, 0, 0, 0, 0],
    EXE: [21, 21, 25, 23, 0, 0, 0, 0],
    CS_BUSINESS: [19, 23, 0, 0, 0, 0, 0, 0],
    CYBER_SECURITY: [19, 22, 0, 0, 0, 0, 0, 0],
    SAFETY_AND_FIRE: [18, 21, 0, 0, 0, 0, 0, 0], 
    VLSI: [21, 21, 0, 0, 0, 0, 0, 0],
  };

  const deptCredits20232025 = {
    CSE: [20, 21, 23, 21, 22, 22, 0, 0],
    IT: [20, 20, 23, 22, 24, 24, 0, 0],
    AIML: [19, 21, 21, 21, 22, 22, 0, 0],
    AIDS: [20, 20, 23, 22, 24, 21, 0, 0],
    CSD: [19, 21, 21, 20, 22, 23, 0, 0],
    EEE: [19, 19.5, 24, 24.5, 23, 23.5, 0, 0],
    ECE: [21, 21, 25, 24, 23, 24, 0, 0],
    BME: [20, 21, 24, 23, 22, 23, 0, 0],
    MECH: [21, 20, 23, 25, 23, 25, 0, 0],
    CIVIL: [21, 20, 23, 21, 24, 23, 0, 0],
    MCT: [21, 21, 22, 24, 24, 22, 0, 0],
    FT: [18, 21, 22, 22, 24, 22, 0, 0],
    EFE: [19, 20.5, 23.5, 25, 0, 0, 0, 0],
    EXE: [21, 21, 25, 23, 0, 0, 0, 0],
    CS_BUSINESS: [19, 23, 0, 0, 0, 0, 0, 0],
    CYBER_SECURITY: [19, 22, 0, 0, 0, 0, 0, 0],
    SAFETY_AND_FIRE: [18, 21, 0, 0, 0, 0, 0, 0],
    VLSI: [21, 21, 0, 0, 0, 0, 0, 0],
  };

  const deptCreditMaps = {
    "2019": deptCredits2019,
    "2023": deptCredits2023,
    "20232025": deptCredits20232025,
  };

  const handleDeptSelect = (regulation, dept) => {
    const creditArray = deptCreditMaps[regulation]?.[dept];
    if (creditArray) {
      setCredits(creditArray);
      setSelectedRegulation(regulation);
    }
  };

  const handleChange = (e) => {
    setSems(Number(e.target.value));
  };

  const handleGpaChange = (index, value) => {
    const newGpas = [...gpas];
    newGpas[index] = value === "" ? "" : Number(value);
    setGpas(newGpas);
  };

  const handleCreditChange = (index, value) => {
    const newCredits = [...credits];
    newCredits[index] = value === "" ? "" : Number(value);
    setCredits(newCredits);
  };

  const calculateResult = () => {
    let totalPoints = 0;
    let totalCredits = 0;

    for (let i = 0; i < sems; i++) {
      totalPoints += gpas[i] * credits[i];
      totalCredits += credits[i];
    }

    const cgpa = totalCredits > 0 ? (totalPoints / totalCredits).toFixed(3) : 0;
    setResult(cgpa);
  };

  const toggleModal = () => {
    calculateResult();
    setIsOpen(!isOpen);
  };

  return (
    <div className="min-h-screen w-[90%] m-auto pt-12">
      <Helmet>
        <title>CGPA CALC</title>
      </Helmet>
      <h2 className="font-bold text-2xl flex justify-center">CGPA Calculator</h2>
      <h4 className="text-xl flex justify-center py-2">Calculate your overall CGPA here</h4>

      {/* Select number of semesters */}
      <div className="bg-[#21222D] m-4 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
        <span>No of semesters you have completed - </span>
        <select
          onChange={handleChange}
          value={sems}
          className="bg-[#242C3C] text-white rounded-md outline-none p-2"
        >
          {[...Array(8)].map((_, i) => (
            <option key={i} value={i + 1}>{i + 1}</option>
          ))}
        </select>
      </div>

      {/* Department dropdowns for 2019, 2023, and 2023 (2025 batch) */}
      <div className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
        <span className="block mb-2 font-semibold text-white">Select Your Regulation & Department - </span>
        <div className="flex flex-col gap-4">
          <div>
            <label className="mr-2 text-white">2019 Regulation:</label>
            <select
              onChange={(e) => handleDeptSelect("2019", e.target.value)}
              className="bg-[#242C3C] text-white rounded-md outline-none p-1"
              defaultValue=""
              disabled={selectedRegulation && selectedRegulation !== "2019"}
            >
              <option value="" disabled>Select Department</option>
              {Object.keys(deptCredits2019).map((dept) => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="mr-2 text-white">2023 Regulation (2023, 2024 Batch):</label>
            <select
              onChange={(e) => handleDeptSelect("2023", e.target.value)}
              className="bg-[#242C3C] text-white rounded-md outline-none p-1"
              defaultValue=""
              disabled={selectedRegulation && selectedRegulation !== "2023"}
            >
              <option value="" disabled>Select Department</option>
              {Object.keys(deptCredits2023).map((dept) => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="mr-2 text-white">2023 Regulation (2025, 2026 Batch):</label>
            <select
              onChange={(e) => handleDeptSelect("20232025", e.target.value)}
              className="bg-[#242C3C] text-white rounded-md outline-none p-1"
              defaultValue=""
              disabled={selectedRegulation && selectedRegulation !== "20232025"}
            >
              <option value="" disabled>Select Department</option>
              {Object.keys(deptCredits20232025).map((dept) => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Reset Button */}
        {selectedRegulation && (
          <button
            onClick={() => {
              setSelectedRegulation(null);
              setCredits(Array(8).fill(0));
            }}
            className="mt-4 px-4 py-2 text-sm bg-red-600 text-white rounded-md"
          >
            Reset Selection
          </button>
        )}
      </div>

      {/* GPA and credit inputs */}
      <div>
        {[...Array(sems)].map((_, i) => (
          <div key={i} className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
            <span>Sem {i + 1} GPA</span>
            <input
              className="bg-[#242C3C] ml-2 p-2 rounded-md w-12 outline-none"
              type="number"
              value={gpas[i]}
              onChange={(e) => handleGpaChange(i, e.target.value)}
            />
            <span className="ml-2">Credits</span>
            <input
              className="bg-[#242C3C] ml-4 p-2 rounded-md w-16 outline-none"
              type="number"
              value={credits[i]}
              onChange={(e) => handleCreditChange(i, e.target.value)}
            />
          </div>
        ))}
      </div>

      {/* Calculate button */}
      <button
        className="m-auto flex items-center justify-center px-6 py-2.5 mb-2 text-sm font-semibold text-white transition duration-300 ease-in-out bg-blue-700 rounded-lg hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300"
        onClick={toggleModal}
      >
        CGPA Calculator
      </button>

      {/* Result Modal */}
      <Modal toggleModal={toggleModal} isOpen={isOpen} setIsOpen={setIsOpen} result={result} gpas={gpas} credits={credits} sems={sems} />
    </div>
  );
};

export default CGPA;


// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import Modal from "../../components/Modal";

// const CGPA = () => {
//   const [sems, setSems] = useState(8);
//   const [result, setResult] = useState(0);
//   const [isOpen, setIsOpen] = useState(false);

//   const [gpas, setGpas] = useState(Array(8).fill(0));
//   const [credits, setCredits] = useState(Array(8).fill(0));

//   const handleChange = (e) => {
//     setSems(Number(e.target.value));
//   };

//   // const handleGpaChange = (index, value) => {
//   //   const newGpas = [...gpas];
//   //   newGpas[index] = Number(value);
//   //   setGpas(newGpas);
//   // };

//   // const handleCreditChange = (index, value) => {
//   //   const newCredits = [...credits];
//   //   newCredits[index] = Number(value);
//   //   setCredits(newCredits);
//   // };

//   const handleGpaChange = (index, value) => {
//     const newGpas = [...gpas];
//     newGpas[index] = value === "" ? "" : Number(value); // Keep empty string if erased
//     setGpas(newGpas);
//   };
  
//   const handleCreditChange = (index, value) => {
//     const newCredits = [...credits];
//     newCredits[index] = value === "" ? "" : Number(value); // Keep empty string if erased
//     setCredits(newCredits);
//   };  

//   const calculateResult = () => {
//     let totalPoints = 0;
//     let totalCredits = 0;
    
//     for (let i = 0; i < sems; i++) {
//       totalPoints += gpas[i] * credits[i];
//       totalCredits += credits[i];
//     }

//     const cgpa = totalCredits > 0 ? (totalPoints / totalCredits).toFixed(3) : 0;
//     setResult(cgpa);
//   };

//   const toggleModal = () => {
//     calculateResult();
//     setIsOpen(!isOpen);
//   };

//   return (
//     <div className="min-h-screen w-[90%] m-auto pt-12">
//       <Helmet>
//         <title>CGPA CALC</title>
//       </Helmet>
//       <h2 className="font-bold text-2xl flex justify-center">CGPA Calculator</h2>
//       <h4 className="text-xl flex justify-center py-2">Calculate your overall CGPA here</h4>

//       <div className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
//         <span>No of semesters you have completed -</span>
//         <select
//           onChange={handleChange}
//           value={sems}
//           className="bg-[#242C3C] text-white rounded-md outline-none p-1"
//         >
//           {[...Array(8)].map((_, i) => (
//             <option key={i} value={i + 1}>{i + 1}</option>
//           ))}
//         </select>
//       </div>

//       <div>
//         {[...Array(sems)].map((_, i) => (
//           <div key={i} className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
//             <span>Sem {i + 1} GPA</span>
//             <input
//               className="bg-[#242C3C] ml-2 p-2 rounded-md w-12 outline-none"
//               type="number"
//               value={gpas[i]}
//               onChange={(e) => handleGpaChange(i, e.target.value)}
//             />
//             <span className="ml-2">Credits</span>
//             <input
//               className="bg-[#242C3C] ml-4 p-2 rounded-md w-16 outline-none"
//               type="number"
//               value={credits[i]}
//               onChange={(e) => handleCreditChange(i, e.target.value)}
//             />
//           </div>
//         ))}
//       </div>

//       <button
//         className="m-auto flex items-center justify-center p-0.5 mb-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-blue-500 to-blue-500 group-hover:from-blue-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-800"
//         onClick={toggleModal}
//       >
//         <span className="px-5 py-2.5 transition-all ease-in duration-75 bg-gray-900 rounded-md group-hover:bg-opacity-0">
//           Calculate
//         </span>
//       </button>

//       <Modal toggleModal={toggleModal} isOpen={isOpen} setIsOpen={setIsOpen} result={result} />
//     </div>
//   );
// };

// export default CGPA;




// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import Modal from "../../components/Modal";

// const CGPA = () => {
//   const [sems, setSems] = useState(8);

//   const [result, setResult] = useState(0);

//   const [isOpen, setIsOpen] = useState(false);

//   const [one, setOne] = useState(0);
//   const [two, setTwo] = useState(0);
//   const [three, setThree] = useState(0);
//   const [four, setFour] = useState(0);
//   const [five, setFive] = useState(0);
//   const [six, setSix] = useState(0);
//   const [seven, setSeven] = useState(0);
//   const [eight, setEight] = useState(0);

//   const handleChange = (e) => {
//     setSems(e.target.value);
//   };

//   const handleChangeInput = (e) => {
//     switch (e.target.name) {
//       case "one":
//         setOne(e.target.value);
//         break;

//       case "two":
//         setTwo(e.target.value);
//         break;

//       case "three":
//         setThree(e.target.value);
//         break;

//       case "four":
//         setFour(e.target.value);
//         break;

//       case "five":
//         setFive(e.target.value);
//         break;

//       case "six":
//         setSix(e.target.value);
//         break;

//       case "seven":
//         setSeven(e.target.value);
//         break;

//       case "eight":
//         setEight(e.target.value);
//         break;

//       default:
//         console.log("hi");
//         break;
//     }
//   };

//   const calculateResult = () => {
//     const totalPoints =
//       Number(one) +
//       Number(two) +
//       Number(three) +
//       Number(four) +
//       Number(five) +
//       Number(six) +
//       Number(seven) +
//       Number(eight);
//     console.log(one);
//     console.warn(totalPoints);
//     setResult((totalPoints / sems).toFixed(2));
//   };

//   const toggleModal = () => {
//     calculateResult();
//     setIsOpen(!isOpen);
//   };

//   const semesters = [
//     {
//       state: one,
//       setState: setOne,
//       text: "Semster 1 GPA",
//       name: "one",
//     },
//     {
//       state: two,
//       setState: setTwo,
//       text: "Semster 2 GPA",
//       name: "two",
//     },
//     {
//       state: three,
//       setState: setThree,
//       text: "Semster 3 GPA",
//       name: "three",
//     },
//     {
//       state: four,
//       setState: setFour,
//       text: "Semster 4 GPA",
//       name: "four",
//     },
//     {
//       state: five,
//       setState: setFive,
//       text: "Semster 5 GPA",
//       name: "five",
//     },
//     {
//       state: six,
//       setState: setSix,
//       text: "Semster 6 GPA",
//       name: "six",
//     },
//     {
//       state: seven,
//       setState: setSeven,
//       text: "Semster 7 GPA",
//       name: "seven",
//     },
//     {
//       state: eight,
//       setState: setEight,
//       text: "Semster 8 GPA",
//       name: "eight",
//     },
//   ];

//   return (
//     <div className="min-h-screen w-[90%] m-auto pt-12">
//       <Helmet>
//         <title>CGPA CALC</title>
//       </Helmet>
//       <h2 className="font-bold text-2xl flex justify-center">
//         CGPA Calculator
//       </h2>
//       <h4 className="text-xl flex justify-center py-2">
//         Calculate your overall CGPA here
//       </h4>
//       <div className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto">
//         <span>No of semesters you have completed-</span>
//         <select
//           onChange={handleChange}
//           value={sems}
//           className="bg-[#242C3C] text-white rounded-md outline-none p-2"
//         >
//           <option value={1}>1</option>
//           <option value={2}>2</option>
//           <option value={3}>3</option>
//           <option value={4}>4</option>
//           <option value={5}>5</option>
//           <option value={6}>6</option>
//           <option value={7}>7</option>
//           <option value={8}>8</option>
//         </select>
//       </div>

//       <div>
//         {semesters.slice(0, sems).map((semester, i) => (
//           <div
//             key={i}
//             className="bg-[#21222D] m-5 p-4 shadow-md rounded-lg max-w-xl ml-auto mr-auto"
//           >
//             <span>{semester.text}</span>
//             <input
//               className="bg-[#242C3C] ml-4 p-2 rounded-md w-16 outline-none"
//               type="number"
//               name={semester.name}
//               value={semester.state}
//               onChange={handleChangeInput}
//             />
//           </div>
//         ))}
//       </div>

//       <button
//         className=" m-auto flex items-center justify-center p-0.5 mb-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-blue-500 to-blue-500 group-hover:from-blue-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-800"
//         onClick={toggleModal}
//       >
//         <span className="px-5 py-2.5 transition-all ease-in duration-75 bg-gray-900 rounded-md group-hover:bg-opacity-0">
//           Calculate
//         </span>
//       </button>

//       <Modal
//         toggleModal={toggleModal}
//         isOpen={isOpen}
//         setIsOpen={setIsOpen}
//         result={result}
//       />
//     </div>
//   );
// };

// export default CGPA;
